import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { Toaster } from 'sonner';
import { ElementRegistryProvider } from '@eaco/forms-ui-web';
import App from './App';
import { apolloClient } from './lib/apolloClient';
import { formsAppElementRegistry } from './lib/formsAppElementRegistry';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <ElementRegistryProvider registry={formsAppElementRegistry}>
        <BrowserRouter>
          <App />
          <Toaster richColors closeButton position="top-right" />
        </BrowserRouter>
      </ElementRegistryProvider>
    </ApolloProvider>
  </React.StrictMode>,
);
